import { db } from './firebase';

export const activityLogsCollection = db.activityLogs;
export const applicationsCollection = db.applications;
export const companiesCollection = db.companies;
export const referrersCollection = db.referrers;
export const conversationsCollection = db.conversations;
export const applicantsCollection = db.applicants;
export const notificationsCollection = db.notifications;
export const mentorsCollection = db.mentors;
export const appointmentRequestsCollection = db.appointmentRequests;